import { PageContent, StyledPage } from 'components/Layout/Page/Page.styled';
import { useTitle } from 'hooks/useTitle';
import { ReactNode } from 'react';

type PageProps = {
  title?: string;
  children: ReactNode;
};

export const Page = ({ title, children }: PageProps) => {
  useTitle(title);

  return (
    <StyledPage>
      <PageContent>{children}</PageContent>
    </StyledPage>
  );
};
